import { Component, ElementRef, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';

@Component({
  selector: 'fi-history-note',
  templateUrl: './note.component.html',
  styleUrls: ['./note.component.scss'],
  standalone: false,
})
export class HistoryNoteComponent implements OnChanges {
  @Input() text: string;
  @Input() isEdited: boolean;
  @Output() textEdited = new EventEmitter<string>();
  @ViewChild('editor') editor: ElementRef;

  editedText = '';

  constructor() {

  }

  ngOnChanges( changes: SimpleChanges ): void {
    if ( !this.isEdited && changes.text ) {
      this.editedText = changes.text.currentValue ?? '';
    }

    if ( changes.isEdited?.currentValue ) {
      setTimeout(() => {
        this.editor.nativeElement?.focus();
        this.editedText = this.text;
        this.resizeEditor();
      }, 50)
    }
  }

  onFinishEdit( event?: Event ): void {
    event?.preventDefault();

    setTimeout(() => {
      this.isEdited = false;
      this.textEdited.emit(this.editedText);
    }, 100)

  }

  resizeEditor(): void {
    if ( this.editor.nativeElement ) {
      const editor = this.editor.nativeElement as HTMLTextAreaElement;

      while ( editor.clientHeight + 10 > Math.max(editor.scrollHeight, 50) ) {
        editor.style.height = (editor.clientHeight - 10) + 'px';
      }

      while ( editor.clientHeight < editor.scrollHeight ) {
        editor.style.height = (editor.clientHeight + 10) + 'px';
      }
    }
  }
}
